export default "__VITE_ASSET__b522825b__"